// src/assets/metadata/episodes.js

// Import the audio files and images
import show1Audio from '../audio/Show 1 EP1 .wav';
import show2Audio from '../audio/Show 2 EP1.mp3';
import show1Card from '../cards/Show 1 Card.png';
import show2Card from '../cards/Show 2 Card.png';

// Live stream configuration
export const liveStream = {
  url: 'https://demo.unified-streaming.com/k8s/live/stable/live.isml/.m3u8',
  title: 'שידור חי - רדיו שבלולים',
  description: 'הצטרפו אלינו לשידור חי של תוכן מקורי ומוזיקה מיוחדת',
};

export const episodes = [
  {
    id: 'ep1',
    url: show1Audio,
    title: 'פרק 1 - הקדמה לשבלולים',
    description: 'בפרק הראשון אנחנו מדברים על התחלת המסע שלנו ברדיו שבלולים, איך הכל התחיל ולמה דווקא שבלולים?',
    duration: '45:30',
    date: '2024-01-15',
    thumbnail: show1Card,
    tags: ['introduction', 'snails', 'radio']
  },
  {
    id: 'ep2',
    url: show2Audio,
    title: 'פרק 2 - חיי השבלול בטבע',
    description: 'מסע מרתק אל עולמם של השבלולים בטבע. נלמד על אורח חייהם, התנהגותם החברתית והאתגרים איתם הם מתמודדים.',
    duration: '38:15',
    date: '2024-01-22',
    thumbnail: show2Card,
    tags: ['nature', 'biology', 'snails']
  },
  {
    id: 'ep3',
    url: '/assets/audio/episodes/ep3.m3u8',
    title: 'פרק 3 - מוזיקה ושבלולים',
    description: 'האם שבלולים אוהבים מוזיקה? בפרק הזה נחקור את הקשר המפתיע בין שבלולים לצלילים, ונשמע מוזיקה מיוחדת שנכתבה בהשראת תנועתם האיטית והמהפנטת.',
    duration: '42:20',
    date: '2024-01-29',
    thumbnail: '/assets/images/thumbnails/ep3.jpg',
    tags: ['music', 'art', 'snails']
  },
  {
    id: 'ep4',
    url: '/assets/audio/episodes/ep4.m3u8',
    title: 'פרק 4 - שבלולים בתרבות',
    description: 'מסע מרתק בעקבות השבלול בתרבות האנושית: מסמלים עתיקים ועד אמנות מודרנית. נספר סיפורים, אגדות ומיתוסים על שבלולים מכל העולם.',
    duration: '40:45',
    date: '2024-02-05',
    thumbnail: '/assets/images/thumbnails/ep4.jpg',
    tags: ['culture', 'history', 'stories']
  }
];

export const categories = [
  { id: 'all', name: 'הכל' },
  { id: 'nature', name: 'טבע' },
  { id: 'culture', name: 'תרבות' },
  { id: 'music', name: 'מוזיקה' },
  { id: 'stories', name: 'סיפורים' }
];